/**
 * Closed vocabulary of entity kinds a DMS page may publish into the assistant's entity context.
 * A kind is the ONLY way an entity id is associated with an entity type on the wire — the contract
 * deliberately has no untyped `id`, so a business-case id can never fill a vehicle route parameter.
 *
 * Unlike `ASSISTANT_ENTITY_TYPES` (an open display vocabulary for entity cards), this list is
 * closed: `assistantEntityContextSchema` rejects unknown keys, the DMS route catalog may only
 * declare parameter sources from these kinds, and `ASSISTANT_CHAT_BODY_LIMIT_BYTES` sizes the
 * request against its length. Keep the schema shape in lockstep (conformance test).
 */
export const ASSISTANT_CONTEXT_ENTITY_KINDS = [
  'businessCase',
  'customer',
  'interest',
  'rentalOrder',
  'vehicle',
] as const;

export type AssistantContextEntityKind = (typeof ASSISTANT_CONTEXT_ENTITY_KINDS)[number];
